import { generateIcsEvent, generateIcsBlob, generateIcsUrl } from "./ics-url-generator.js";
const getICSEvent = ({ id, description, name, location, timeSlot }) => {
  const {
    town,
    streetName,
    streetNumber,
    additionalStreetInfo,
    postalCode,
    lat,
    lon,
    name: locationName
  } = location;
  const icsEvent = generateIcsEvent({
    title: name,
    description: description ? description : name,
    location: `${town} - ${streetName}${streetNumber ? ` ${streetNumber}` : ""}${additionalStreetInfo ? `, ${additionalStreetInfo}` : ""}${postalCode ? `, ${postalCode}` : ""}`,
    start: timeSlot.from,
    end: timeSlot.until,
    lat,
    lon,
    name: locationName,
    id
  });
  const icsBlob = generateIcsBlob(icsEvent);
  window.navigator.msSaveOrOpenBlob ? window.navigator.msSaveOrOpenBlob(icsBlob, "appointment") : window.open(generateIcsUrl(icsBlob), "_blank");
};
export {
  getICSEvent
};
//# sourceMappingURL=get-ics-event.js.map
